export default {
    macro_category: [],
    category: [],
    macro_category_total: []
};